/* eslint-disable
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const co = require('co');

const deps = [require('angular-ui-router'), require('ui/web/clientOverview/form').name];

module.exports = angular
  .module('bench.app.mainapp.details.overview.form.addon', deps)

  .config($stateProvider =>
    $stateProvider.state('bench.details.overview.form.addon', {
      url: '/addon/{addOnId:[0-9]*}',
      views: {
        'modal@': {
          controller($stateParams, AddOn) {
            const { addOnId } = $stateParams;
            this.addOn = new AddOn(addOnId);

            return this;
          },
          controllerAs: 'vm',
          template: `\
<bl-client-overview-form add-on="vm.addOn"></bl-client-overview-form>\
`,
        },
      },
    }),
  );
